/**
 * Kan deze tablet zijn echte schermverlichting regelen (APK ≥ 1.0.5)? Pas bekend na de
 * eerste poging; tot dan `null`. `DimOverlay` leest dit: waar het native kan, is de zwarte
 * CSS-laag overbodig — en schadelijk, want die dimt bovenop de al gedimde verlichting.
 */
import { KeepAliveBridge } from '../native/KeepAliveBridge';

let supported: boolean | null = null;
const listeners = new Set<() => void>();

export function subscribeNativeBrightness(cb: () => void) {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

export function getNativeBrightness(): boolean | null {
  return supported;
}

/** `value` 0..1, of < 0 = de helderheid van het toestel zelf. */
export async function setScreenBrightness(value: number, durationMs = 0): Promise<void> {
  const ok = await KeepAliveBridge.setWindowBrightness(value, durationMs);
  if (supported !== ok) {
    supported = ok;
    listeners.forEach((l) => l());
  }
}

/** Alleen voor tests. */
export function __resetNativeBrightness() {
  supported = null;
}
